module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAA1CAMAAABlcHtYAAAAM1BMVEUAAAD///////////////////////////////////////////////////////////////+3leKCAAAAEHRSTlMA3yDvz4AwEF+gUHC/kECvbzPFoAAAAKhJREFUOMu91MsOwiAQheEpDNACxXn/pzVesAvH3zQmnu0XF54zRaSqaRU/1W5ZfVS7Z7hoj8TsYZwaHNztmcXRspCGQwupOprj1Iu8Z9jM5uj60uRoQ03f9eMIO+pmNIIajFAUa/7DCF1IeYRGIyzipE/FX54bPsPJhON/YkPUPBntSZdANwTXV+FuG1gi+6Vs/rLPl03mlAYmEYxfzT7L9jLgpcY3/gpnjxy1wb9iYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/icon-right.png
// module id = 5YQP
// module chunks = 0